import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import { useTranslation } from "react-i18next";

const ErrorPage = (props) => {
  const { t: translator } = useTranslation();
  const { tenantId } = useContext(AuthContext);
  let code = props.match.params.code;

  useEffect(() => {
    document.body.id = "";
  }, []);

  return (
    <div className="container">
      <div className="text-center mt-4">
        <p style={{ fontSize: 150 }}>{code}</p>
        <span className="text-center text-dark mt-4">
          {translator("Access-Denied")}{" "}
          <Link
            style={{ cursor: "pointer" }}
            to={Number(tenantId) ? `/tenants/${tenantId}` : "/"}
          >
            {translator("backHome")}
          </Link>{" "}
          {translator("or")}{" "}
          <Link style={{ cursor: "pointer" }} to="/login">
            {translator("login")}
          </Link>
          .
        </span>
      </div>
    </div>
  );
};

export default ErrorPage;
